module.exports = __webpack_public_path__ + "img/curved-rail-vertical-right-bottom-ties.a3485fa7.png";